import PropTypes from 'prop-types';
import React from 'react';
import ToggleButtons from '../shared/toggle-buttons/toggle-buttons';

const SalesRentals = ({changeFilter, resultState}) => {
  return (
    <div className="aw-sale-rental simple-toggle">
      <ToggleButtons
        name="listingType"
        options={[]
          .concat(resultState.salesCount > 0 ? [{ label: `Sales (${resultState.salesCount})`, value: 'sale' }] : [])
          .concat(resultState.rentalsCount > 0 ? [{ label: `Rentals (${resultState.rentalsCount})`, value: 'rental' }] : [])
        }
        value={resultState.filter.listingType}
        onChange={(e) => changeFilter('listingType', e.target.value)}
        labelClass=""
      />
    </div>
  );
};

SalesRentals.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  resultState: PropTypes.object.isRequired
};

export default SalesRentals;



// WEBPACK FOOTER //
// ./src/components/my-listings/sales-rentals.js